import { cache } from '@tencent/ppd-base-libs';
import { reactive } from '@vue/composition-api';
import { myPromise } from '../utils/promise-handler';
import { getCurMonth } from '../utils/date-helper';

// /** 判断该任务是否为新手任务（需要弹出新手指引） */
// const NEW_USER_TASK_ID = ['new_user_month'];
// export const isNewUserTask = (taskId?: string) => NEW_USER_TASK_ID.includes(taskId || '');


// 逻辑：
// 如果今个月有新手任务，那么cgi查回来，就set isNeedShow=true
// 尝试执行签到任务，签到成功就isShow=true，localStorage留个底
// 如果今个月没有新手任务，那么cgi查回来没有，就不会isNeedShow=true

const STORAGE_KEY = 'newUserGuideShowed';
const STORAGE_TIME = 1000 * 60 * 60 * 24 * 365 * 1;

/** 是否已经展示过 */
// const isShowed = () => cache.getItemSync(STORAGE_KEY);

const promiseHandler = myPromise();
const showConfig = reactive({
  isShow: false,
  isNeedShow: false,
});

export const useGuideDriver = () => {
  const setIsNeedShow = () => {
    showConfig.isNeedShow = true;
  };
  const startGuide = async () => {
    // 新手指引是否展示完全依赖是否有返回对应任务，这里localStorage只是留个底
    cache.setItemSync(STORAGE_KEY, getCurMonth(), STORAGE_TIME);
    showConfig.isShow = true;
    showConfig.isNeedShow = true;
    return promiseHandler.p;
  };

  const endGuide = () => {
    showConfig.isShow = false;
    promiseHandler.res(true);
  };

  return {
    /** 开启新手指引 */
    startGuide,
    /** 结束新手指引 */
    endGuide,
    /** 展示信息配置 */
    showConfig,
    /** 设置为需要展示 */
    setIsNeedShow,
  };
};
